import * as WorkOrder from "@common/application/entities/WorkOrder";
import { MfGeneratedFormComponent } from "./mf-generated-form.component";
import * as Invoice from "@common/application/entities/Invoice";
import * as JobCard from "@common/application/entities/JobCard";
import * as User from "@common/application/entities/User";
import * as Role from "@common/application/entities/Role";
import * as Organisation from "@common/application/entities/Organisation";
import * as PartyAddress from "@common/application/entities/PartyAddress";
import * as PartyContact from "@common/application/entities/PartyContact";
import * as Requisition from "@common/application/entities/Requisition";
import * as RequisitionItem from "@common/application/entities/RequisitionItem";
import * as RequisitionItemWorkflow from "@common/application/entities/RequisitionItemWorkflow";
import * as RequisitionWorkflow from "@common/application/entities/RequisitionWorkflow";
import * as StockItem from "@common/application/entities/StockItem";
import * as RequisitionFileCabinet from "@common/application/entities/RequisitionFileCabinet";
import * as RequisitionItemFileCabinet from "@common/application/entities/RequisitionItemFileCabinet";
import * as Site from "@common/application/entities/Site";
import * as Supplier from "@common/application/entities/Supplier";
import * as ProjectJobNumber from "@common/application/entities/ProjectJobNumber";
import * as StockItemSupplier from "@common/application/entities/StockItemSupplier";
import * as StockItemFileCabinet from "@common/application/entities/StockItemFileCabinet";
import * as RequisitionPartial from "@common/application/entities/RequisitionPartial";
import * as SupplierFileCabinet from "@common/application/entities/SupplierFileCabinet";

export class WorkOrderGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: WorkOrder.WorkOrderForm = new WorkOrder.WorkOrderForm();
}

export class InvoiceGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Invoice.InvoiceForm = new Invoice.InvoiceForm();
}

export class JobCardGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: JobCard.JobCardForm = new JobCard.JobCardForm();
}
export class UserGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: User.UserForm = new User.UserForm();
  protected identifierProperty: string = 'displayName';
}
export class OrganisationGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Organisation.OrganisationForm = new Organisation.OrganisationForm();
  protected identifierProperty: string = 'name';
}
export class SiteGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Site.SiteForm = new Site.SiteForm();
  protected identifierProperty: string = 'name';
}
export class ProjectJobNumberGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: ProjectJobNumber.ProjectJobNumberForm = new ProjectJobNumber.ProjectJobNumberForm();
  protected identifierProperty: string = 'name';
}
export class RoleGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Role.RoleForm = new Role.RoleForm();
  protected identifierProperty: string = 'displayName';
}

export class PartyContactSpecificPartGeneratedyForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: PartyContact.PartyContactSpecificPartyForm = new PartyContact.PartyContactSpecificPartyForm();
  protected identifierProperty: string = 'displayName';
}

export class PartyAddresspecificPartyGenerated extends MfGeneratedFormComponent {
  protected detailPageComponentForm: PartyAddress.PartyAddresspecificPartyForm = new PartyAddress.PartyAddresspecificPartyForm();
  protected identifierProperty: string = 'displayName';
}

export class SupplierPartyContactGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: PartyContact.SupplierPartyContactForm = new PartyContact.SupplierPartyContactForm();
  protected identifierProperty: string = 'displayName';
}

export class SupplierPartyAddressGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: PartyAddress.PartyAddressForm = new PartyAddress.PartyAddressForm();
  protected identifierProperty: string = 'displayName';
}


export class RequisitionGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Requisition.RequisitionForm = new Requisition.RequisitionForm();
  protected identifierProperty: string = 'uniqueId';
  public setParentBladeLoading: boolean = true;


};
export class RequisitionItemGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionItem.RequisitionItemForm = new RequisitionItem.RequisitionItemForm();
  protected identifierProperty: string = 'identifier';
  public setParentBladeLoading: boolean = true;
};
export class RequisitionItemWorkflowGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionItemWorkflow.RequisitionItemWorkflowForm = new RequisitionItemWorkflow.RequisitionItemWorkflowForm();
  protected identifierProperty: string = 'displayName';
  protected _canSave: boolean = false;
};
export class RequisitionPartialGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionPartial.RequisitionPartialForm = new RequisitionPartial.RequisitionPartialForm();
  protected identifierProperty: string = 'identifier';
  protected _canSave: boolean = false;
};
//export class RequisitionPartialWorkflowGeneratedForm extends MfGeneratedFormComponent {
//  protected detailPageComponentForm: RequisitionPartialWorkflow.RequisitionPartialWorkflowForm = new RequisitionPartialWorkflow.RequisitionPartialWorkflowForm();
//  protected identifierProperty: string = 'displayName';};
export class RequisitionWorkflowGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionWorkflow.RequisitionWorkflowForm = new RequisitionWorkflow.RequisitionWorkflowForm();
  protected identifierProperty: string = 'displayName';

  protected _canSave: boolean = false;
};
export class RequisitionFileCabinetGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionFileCabinet.RequisitionFileCabinetForm = new RequisitionFileCabinet.RequisitionFileCabinetForm();
  protected identifierProperty: string = 'fileName';
};
export class RequisitionItemFileCabinetGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: RequisitionItemFileCabinet.RequisitionItemFileCabinetForm = new RequisitionItemFileCabinet.RequisitionItemFileCabinetForm();
  protected identifierProperty: string = 'fileName';
};
export class SupplierGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: Supplier.SupplierForm = new Supplier.SupplierForm();
  protected identifierProperty: string = 'name';
};
export class StockItemGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: StockItem.StockItemForm = new StockItem.StockItemForm();
  protected identifierProperty: string = 'code';
};
export class StockItemSupplierGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: StockItemSupplier.StockItemSupplierForm = new StockItemSupplier.StockItemSupplierForm();
  protected identifierProperty: string = 'name';
};
export class StockItemFileCabinetGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: StockItemFileCabinet.StockItemFileCabinetForm = new StockItemFileCabinet.StockItemFileCabinetForm();
  protected identifierProperty: string = 'fileName';
};
export class SupplierFileCabinetGeneratedForm extends MfGeneratedFormComponent {
  protected detailPageComponentForm: SupplierFileCabinet.SupplierFileCabinetForm = new SupplierFileCabinet.SupplierFileCabinetForm();
  protected identifierProperty: string = 'fileName';
};



